/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable */
/* eslint-disable indent */
import React, { useState } from "react";
import { Card, Input, Button, Space, Typography, message, Spin } from "antd";
import { createRoot } from "react-dom/client";
import Heading from "../../../components/Heading";
import urls from "../../../api/urls";
import API from "../../../api";
import { MCNLabel } from "../../../components/MCNLabel";
import { printBase64Pdf } from "../../../utils/printUtils";
import nodeUrls from "../../../api/nodeUrls";
const { GET_SMILE_LABEL_GENERATION } = urls;
const { MCN_LABEL_PRINT } = nodeUrls;
const { Text } = Typography;

const SmileLabelGeneration = () => {
  const [referenceValue, setReferenceValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const mapApiToLabel = (data) => {
    const shipmentDetails = data?.shipmentDetails || {};
    const shipTo = data?.shipTo || {};
    const shipFrom = data?.shipFrom || {};
    const items = data?.items || [];
    const barcodes = data?.barcodes || {};

    return {
      flowType: shipmentDetails?.flowType,
      orderDateTime: shipmentDetails?.orderDate,
      awbNumber: shipmentDetails?.awbNumber,
      topBarcode: barcodes?.awbNumber ? `data:image/png;base64,${barcodes.awbNumber}` : undefined,
      bottomBarcode: barcodes?.barcodeNumber ? `data:image/png;base64,${barcodes.barcodeNumber}` : undefined,
      referenceNumber: shipmentDetails?.barcodeNumber,
      mode: shipmentDetails?.mode?.toUpperCase() || "SURFACE",
      channel: shipmentDetails?.payment || "-",
      weightText: shipmentDetails?.weight,
      lbhText: shipmentDetails?.dimensions,
      shipTo: shipTo?.name,
      shipToMobile: shipTo?.mobile,
      shipToAddressLines: [shipTo?.addressLine1],
      shipToCity: shipTo?.city,
      shipToState: shipTo?.state,
      shipToPincode: shipTo?.pincode,
      routeCity: shipTo?.city,
      routePincode: shipTo?.pincode,
      shipFromTitle: `Ship From - ${shipFrom?.name || ""}`,
      shipFromMobile: shipFrom?.mobile,
      shipFromAddressLines: [
        `${shipFrom?.addressLine1 || ""}${shipFrom?.city ? `, ${shipFrom.city}` : ""}${shipFrom?.state ? `, ${shipFrom.state}` : ""}${shipFrom?.pincode ? ` - ${shipFrom.pincode}` : ""}`,
      ],
      items: (items || []).map((it, idx) => ({
        srNo: it?.srNo ?? idx + 1,
        product: it?.product,
        sku: it?.sku || "-",
        qty: it?.quantity,
        amount: it?.amount,
      })),
    };
  };

  const handlePrint = async () => {
    const awb = inputValue?.trim();
    if (!awb) return;
    if (isLoading) return;
    setIsLoading(true);

    try {
      // Fetch label data from API
      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let hubId = activeHub?.hubId || userInfo?.userInfo?.premiseId;
      const response = await fetch(`${MCN_LABEL_PRINT}?tplAwbNumber=${awb}&hubId=${hubId}`);
      const data = await response.json();

      if (!data) {
        message.error("Failed to fetch label data");
        return;
      }

      if (data?.labelFormat === "LABEL_DATA" && data?.data?.tplLabel) {
        printBase64Pdf(data.data.tplLabel);
        return;
      }

      // Check for necessary data structure for OWN_DATA
      const processingData = data?.data || data;
      if (!processingData || !processingData.shipmentDetails) {
        // If we don't have shipmentDetails and it's not LABEL_DATA, it's likely an invalid response or error
        // But let's check if the API returns an error message in data
        if (data.message) {
          message.error(data.message);
        } else {
          message.error("Invalid label data received");
        }
        return;
      }

      const labelData = mapApiToLabel(processingData);

      // Create a hidden container for printing
      const printContainer = document.createElement("div");
      printContainer.id = "print-container";
      printContainer.style.position = "fixed";
      printContainer.style.top = "0";
      printContainer.style.left = "0";
      printContainer.style.width = "100%";
      printContainer.style.height = "100%";
      printContainer.style.zIndex = "9999";
      printContainer.style.backgroundColor = "white";
      printContainer.style.display = "none";
      printContainer.style.bottom = "0";

      // Add print styles to remove browser headers/footers
      const printStyle = document.createElement("style");
      printStyle.id = "print-style-override";
      printStyle.textContent = `
        @page { margin: 0; size: auto; }
        @media print {
          body { margin: 0; padding: 0; }
          html { margin: 0; padding: 0; }
        }
      `;
      document.head.appendChild(printStyle);
      document.body.appendChild(printContainer);

      // Render the label using React 18 createRoot
      const root = createRoot(printContainer);
      root.render(<MCNLabel {...labelData} />);

      // Wait for render, then print
      setTimeout(() => {
        printContainer.style.display = "block";

        // Hide everything else
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach(child => {
          if (child.id !== "print-container") {
            child.style.display = "none";
          }
        });

        // Trigger print
        window.print();

        // Restore visibility
        bodyChildren.forEach(child => {
          if (child.id !== "print-container") {
            child.style.display = "";
          }
        });

        // Cleanup
        root.unmount();
        document.body.removeChild(printContainer);
        const styleEl = document.getElementById("print-style-override");
        // if (styleEl) {
        //   document.head.removeChild(styleEl);
        // }
      }, 500);

    } catch (error) {
      message.error("Failed to fetch label data");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onPressEnter = (e) => {
    const value = e.target.value;
    const storedPattern = localStorage.getItem("regexPattern");
    if (value.length > 0) {
      if (storedPattern) {
        const cleanPattern = storedPattern?.replace(/^\/|\/$/g, "");
        const regex = new RegExp(cleanPattern);
        if (!regex.test(value)) {
          message.destroy();
          message.error("Invalid AWB number format");
          return;
        }
      }
      message.destroy();
      setReferenceValue(value);
    } else {
      message.destroy();
    }
  };

  return (
    <div className="smile-label-generation" style={{ padding: 16 }}>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin size="large" />
        </div>
      )}
      <Heading title="Smile Label Generation" />
      <Card style={{ marginTop: 12 }}>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Space direction="horizontal" size={8} align="start">
            <Input
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                if (!e.target.value) {
                  message.destroy();
                }
              }}
              placeholder="Enter 3PL number"
              bordered
              style={{ borderRadius: "5px", height: "40px", width: "250px" }}
              maxLength={20}
              suffix={false}
              onKeyPress={(e) => {
                const forbiddenChars = /[@!$#%^&*=+()""";?.><,]/;
                if (forbiddenChars.test(e.key)) {
                  e.preventDefault();
                  message.destroy();
                }
              }}
              onPressEnter={onPressEnter}
            />
            <Button
              className="save-btn"
              onClick={handlePrint}
              disabled={!inputValue?.trim()}
              loading={isLoading}
              style={{ minWidth: "160px", height: "40px" }}
            >
              Print Label
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
};
export default SmileLabelGeneration;
